import NewJobForm, { NewJobFormType as Type } from './NewJobForm.container';

export type NewJobFormType = Type;

export default NewJobForm;
